import Model from '@/models/ExtendModel'

export default class WhOrdererPriority extends Model {
    resource() {
        return 'wh_orderer_priority'
    }
}